module.exports = __webpack_public_path__ + "img/logo.4476457b.png";